import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@honda-canada/design-system-react';
import React from 'react';
import Superscript from '../shared/Superscript';
const TabLabelWithSuperscript = ({ label, superscript }) => (_jsxs(Box, { style: { pointerEvents: 'none' }, children: [label, _jsx(Superscript, { ...superscript, ml: "xxs" })] }));
export default TabLabelWithSuperscript;
